import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v33.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { B as e } from "./base-toolbar.js";
import { H as t } from "./history-manager.js";
import { L as s } from "./utils/auto-pan.js";
var i = "AREA_ID";

var ZoneToolsBase = /*#__PURE__*/function (_e) {
  _inherits(ZoneToolsBase, _e);

  var _super = _createSuper(ZoneToolsBase);

  function ZoneToolsBase(e, i) {
    var _this;

    _classCallCheck(this, ZoneToolsBase);

    _this = _super.call(this, e, i), _this.activeZoneHistory = new t(), _this.entireFieldZones = [], _this.history = new t(), _this.id = "zones", _this.mapListeners = new s(), _this.preventDoubleClick = !1, _this.zones = [], _this.mapView.on("double-click", function (e) {
      _this.preventDoubleClick && e.stopPropagation();
    });
    return _this;
  }

  _createClass(ZoneToolsBase, [{
    key: "activateToolset",
    value: function activateToolset() {
      var _this2 = this;

      this.disabled ? this.reset().then(function () {
        return _this2.resetGraphics();
      }) : (this.activeTool ? this.activateTool(this.activeTool) : this.createMapListeners(), this.resetGraphics());
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;

      return this.reset().then(function () {
        _this3.activeZone = null, _this3.updateZones([], !0, !1);
      }).then(function () {
        return _this3.resetGraphics();
      });
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return {
        top: 0,
        left: 210,
        leftAndRight: !0,
        width: 430,
        height: 51
      };
    }
  }, {
    key: "getRestoreId",
    value: function getRestoreId(e) {
      return "".concat(this.id, "-").concat(e);
    }
  }, {
    key: "removeMapListeners",
    value: function removeMapListeners() {
      this.mapListeners.removeAll();
    }
  }, {
    key: "resetTools",
    value: function resetTools() {
      var _this4 = this;

      setTimeout(function () {
        return _this4.unSelectTools();
      });
    }
  }, {
    key: "resetZones",
    value: function resetZones() {
      console.assert(this.entireFieldZones.length > 0), this.setZones(this.entireFieldZones), this.callResetZones(this.entireFieldZones);
    }
  }, {
    key: "setCurrentAreaId",
    value: function setCurrentAreaId(e) {
      if (!this.activeZone || this.activeZone.attributes.AREA_ID !== e) {
        var _t = this.zones.find(function (t) {
          return t.attributes.AREA_ID === e;
        });

        _t ? this.activateZone(_t) : this.clearActiveZone();
      }
    }
  }, {
    key: "setToolbarMenuInset",
    value: function setToolbarMenuInset(e) {
      var t = e ? [e] : [];
      return this.autoPan.setInsets(t), this.polygonCreator.setInsets(t), t;
    }
  }]);

  return ZoneToolsBase;
}(e);

export { i as A, ZoneToolsBase as Z };